import { Loader } from "@googlemaps/js-api-loader";

const GoogleMap = {
  library: null,
  renderer: {
    render: function ({ count, position }, stats) {
      // create svg url with fill color
      const svg = window.btoa(`
			<svg fill="#242538" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
			  <circle cx="120" cy="120" opacity=".6" r="70" />
			  <circle cx="120" cy="120" opacity=".3" r="90" />
			  <circle cx="120" cy="120" opacity=".2" r="110" />
			</svg>`);
      // create marker using svg icon
      return new google.maps.Marker({
        position,
        icon: {
          url: `data:image/svg+xml;base64,${svg}`,
          scaledSize: new google.maps.Size(50, 50),
        },
        label: {
          text: String(count),
          color: "#fff",
          fontSize: "12px",
        },
        // adjust zIndex to be above other markers
        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
      });
    },
  },

  /**
   * Create google map
   */
  create(data, mapEl, locations) {
    if (!GoogleMap.library) {
      const loader = new Loader({
        apiKey: google_api_key,
        version: "weekly",
      });

      loader.load().then((google) => {
        GoogleMap.library = google.maps;
        GoogleMap.createMap(data, mapEl, locations);
      });
    } else {
      GoogleMap.createMap(data, mapEl, locations);
    }
  },

  createMap(data, mapEl, locations) {
    const pos = {
      lat: data.lat,
      lng: data.lng,
    };

    let viewportWidth = window.innerWidth;

    const map_options = {
      zoom: data.zoom,
      center: pos,
      disableDefaultUI: true,
      zoomControl: viewportWidth > 600 ? true : false,
      styles: GoogleMap.styles,
    };

    const map = new GoogleMap.library.Map(mapEl[0], map_options);

    map.markers = [];

    // Add markers
    locations.forEach((loc) => {
      const marker = GoogleMap.addMarker(loc, map);

      if (loc.url) {
        marker.addListener("click", () => {
          let hash = loc.url.slice(1);

          const viewportWidth = window.innerWidth;

          const targetElement = document.getElementById(hash);
          if (targetElement) {
            const headerOffset = (viewportWidth > 1200) ? 200 : 100;
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        });
      }

      map.markers.push(marker);
    });

    // Add bounds
    if (locations.length > 1) {
      const bounds = new GoogleMap.library.LatLngBounds();
      locations.forEach((pos) => {
        bounds.extend(pos);
      });
      map.fitBounds(bounds);
    }
  },

  /**
   * Create map marker
   */
  addMarker(loc, map) {
    // marker icon
    let icon = {
      url: `${window.location.origin}/themes/base/resources/src/img/vaks-map-pin.svg`,
      size: new GoogleMap.library.Size(31, 61),
    };
    if (loc.type && "partner" == loc.type) {
      icon = {
        url: `${window.location.origin}/themes/base/resources/src/img/vaks-map-partner-pin.svg`,
        size: new GoogleMap.library.Size(16, 30),
      };
    }

    // Marker options
    const marker_options = {
      position: {
        lat: loc.lat,
        lng: loc.lng,
      },
      optimized: false,
      map,
      icon,
      animation: GoogleMap.library.Animation.DROP,
    };

    return new GoogleMap.library.Marker(marker_options);
  },

  styles: [
    {
      featureType: "all",
      elementType: "labels.text.fill",
      stylers: [
        {
          saturation: 36,
        },
        {
          color: "#333333",
        },
        {
          lightness: 40,
        },
      ],
    },
    {
      featureType: "all",
      elementType: "labels.text.stroke",
      stylers: [
        {
          visibility: "on",
        },
        {
          color: "#ffffff",
        },
        {
          lightness: 16,
        },
      ],
    },
    {
      featureType: "all",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#fefefe",
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#a4a3a3",
        },
        {
          lightness: 17,
        },
        {
          weight: 1.2,
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "labels",
      stylers: [
        {
          visibility: "on",
        },
      ],
    },
    {
      featureType: "administrative.country",
      elementType: "labels",
      stylers: [
        {
          visibility: "on",
        },
        {
          weight: "1",
        },
      ],
    },
    {
      featureType: "administrative.country",
      elementType: "labels.text",
      stylers: [
        {
          visibility: "on",
        },
      ],
    },
    {
      featureType: "landscape",
      elementType: "geometry",
      stylers: [
        {
          color: "#f5f5f5",
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [
        {
          color: "#f5f5f5",
        },
        {
          lightness: 21,
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [
        {
          color: "#dedede",
        },
        {
          lightness: 21,
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 17,
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 29,
        },
        {
          weight: 0.2,
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 18,
        },
      ],
    },
    {
      featureType: "road.local",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 16,
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [
        {
          color: "#f2f2f2",
        },
        {
          lightness: 19,
        },
      ],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [
        {
          color: "#e9e9e9",
        },
        {
          lightness: 17,
        },
      ],
    },
  ],
};

export default GoogleMap;
